export interface IDayWithHours {
    day: number,
    hours: number[]
}